$(document).ready(function() {
var isMobile = $(window).width() <= 768;
// Mobile tab toggle functionality
if ($(window).width() <= 768) {
  $(".template-page .shopify-section").each(function() {
    var button = $(this).find(".stse_drop_dwon");
    button.on("click", function() {
      var togglDataState = $(this).closest(".true_Tab_data").find(".toggl_data_state");
      $(".true_Tab_data .toggl_data_state").each(function() {
        if ($(this)[0] !== togglDataState[0]) {
          $(this).removeClass("mobile_data_store"); 
        }
      });
      togglDataState.toggleClass("mobile_data_store");
    });
  });
}
// desktop
else{
$(".template-page .shopify-section").each(function() {
var button = $(this).find(".stse_drop_dwon");
button.on("click", function() {
var container = $(this).closest(".true_Tab_data").find(".store-list-container");
var togglDataState = $(this).closest(".true_Tab_data").find(".toggl_data_state");
var currentScrollPos = $(window).scrollTop();
$(".store-list-container").not(container).each(function() {
if (isMobile) {
$(this).css("display", "none");
$(this).prev(".stse_drop_dwon").removeClass("activated");
$(this).closest(".true_Tab_data").find(".toggl_data_state").removeClass("actived_main_stse");
} else {
$(this).css("max-height", "0");
$(this).prev(".stse_drop_dwon").removeClass("activated");
$(this).closest(".true_Tab_data").find(".toggl_data_state").removeClass("actived_main_stse");
}
});
if (container.length) {
if (isMobile) {
if (container.css("display") !== "none") {
container.css("display", "none");
$(this).removeClass("activated");
togglDataState.removeClass("actived_main_stse");
} else {
container.css("display", "block");
$(this).addClass("activated");
togglDataState.addClass("actived_main_stse");
}
} else {
if (container.css("max-height") !== "0px") {
container.css("max-height", "0");
$(this).removeClass("activated");
togglDataState.removeClass("actived_main_stse");
} else {
container.css("max-height", container[0].scrollHeight + "px");
$(this).addClass("activated");
togglDataState.addClass("actived_main_stse");
}
}
}
$(window).scrollTop(currentScrollPos);
});
});

}
// js for all pages
$(".custom-mainbody-all-stores .tab_data_all_countr .inner_all_countr_data_tab").click(function () {
  var selectedAttr = $(this).attr("data-attr");
  $(".custom-mainbody-all-stores .tab_data_all_countr .inner_all_countr_data_tab").removeClass("tab_active_kl");
  $(this).addClass("tab_active_kl");
  $(".main_state_data_tab.true_Tab_data").each(function () {
    var currentAttr = $(this).attr("data-attr");
    if (currentAttr === selectedAttr) {
      $(this).show();  
      if (selectedAttr !== "india") {
        $(this).find(".stse_drop_dwon").trigger("click"); 
        $(this).find(".stse_drop_dwon").hide();  
      }
    } else {
      $(this).hide();
    }
  });
});
$(".inner_all_countr_data_tab[data-attr='india']").click();
if (!document.body.classList.contains('custom-mainbody-all-stores')) {
var max_ht = -1;
$(".toggl_data_state .store-item").each(function() {
var h = $(this).find(".inner_height_data").height(); 
max_ht = h > max_ht ? h : max_ht;
});
$(".inner_height_data").height(max_ht)
}
// url track
var hash = window.location.hash.substring(1);  
  $(".shopify-section.store_sectin_data").each(function() {
    var sectionId = $(this).find(".main_state_data_tab").attr("id");
    if (sectionId === hash) {
      $(this).find(".stse_drop_dwon").trigger("click");
      $(this).addClass("blinking");
      var parentSectionOffset = $(this).offset().top - 200; 
      $('html, body').animate({
        scrollTop: parentSectionOffset
      }, 200, function() {
        $(this).removeClass("blinking");
      });
    }
  });
$(".menu-list__list-item.Custom_Menu_stores ul.list-unstyled.sub-child-menu").click(function(event) {
setTimeout(function() {
location.reload();  
}, 800); 
})

});

